const ROL_ADMIN = 1; // 'Administrador'
const ROL_EMPLEADO = 2; // 'Usuario Empleado'
const ROL_CLIENTE = 3; // 'Usuario Básico'

module.exports = {
    ROL_ADMIN,
    ROL_EMPLEADO,
    ROL_CLIENTE
};